/**
 * Display configuration for auth-status comment tags.
 *
 * Maps each backend `comment_type` value to the label and colour pair
 * used by the Tags pill in the chat timeline.
 *
 * @module commentTypeConfig
 */

import { AuthStatusChangeComments } from "../../../../../data-model/authStatusChangeComments";

/** Union of recognised backend `comment_type` values. */
export type AuthStatusCommentType = AuthStatusChangeComments["comment_type"];

/** Human-readable tag labels keyed by backend comment_type. */
export const COMMENT_TYPE_TO_TAG_LABEL: Record<AuthStatusCommentType, string> =
  {
    denial: "Denial",
    query: "Query Raised",
    query_resolution: "Query Resolved",
    hold: "Hold",
  };

/** Tag text colours keyed by backend comment_type. */
export const COMMENT_TYPE_TO_TAG_FORE_GROUND_COLOR: Record<
  AuthStatusCommentType,
  string
> = {
  denial: "#CC0300",
  query: "#4B00CC",
  query_resolution: "#005D49",
  hold: "#B45309",
};

/** Tag background colours keyed by backend comment_type. */
export const COMMENT_TYPE_TO_TAG_BACKGROUND_COLOR: Record<
  AuthStatusCommentType,
  string
> = {
  denial: "#FFE8E8",
  query: "#F6E5FF",
  query_resolution: "#E6F3F0",
  hold: "#FEF3C7",
};

/** Fallback label for unrecognised comment types. */
export const DEFAULT_TAG_LABEL = "Comment";

/** Fallback text colour (neutral grey) for unrecognised comment types. */
export const DEFAULT_TAG_FORE_GROUND_COLOR = "#525252";

/** Fallback background colour (neutral grey) for unrecognised comment types. */
export const DEFAULT_TAG_BACKGROUND_COLOR = "#F5F5F5";
